import { stringMasterAchievement } from './helpers';

export default stringMasterAchievement(4, 'D', 22);
